import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Space, Switch, Tag } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { cmsLanguageName, supportedLanguages } from "../../helpers/language.js";
import { getTimeAgo } from "../../utilities/intl.js";
import { generateRouteUrl } from "../routes.js";

export const TemplateListColumns = (fetcher) => [
  {
    title: "Edit",
    key: "edit",
    fixed: "left",
    width: 80,
    render: (_, record) =>
      record.multilingual ? (
        <Dropdown
          menu={{
            items: supportedLanguages.map((language) => ({
              key: language,
              label: (
                <Link
                  key={language}
                  to={generateRouteUrl("EmailTemplateDetails", {
                    id: record.id,
                    language,
                  })}
                >
                  {cmsLanguageName(language)}
                </Link>
              ),
            })),
          }}
        >
          <Button size="small" type="primary" icon={<DownOutlined />}>
            Edit
          </Button>
        </Dropdown>
      ) : (
        <Link
          to={generateRouteUrl("EmailTemplateDetails", {
            id: record.id,
            language: "default",
          })}
        >
          <Button size="small" type="primary">
            Edit
          </Button>
        </Link>
      ),
  },
  {
    title: "History",
    dataIndex: "id",
    fixed: "left",
    width: 90,
    render: (id) => (
      <Link
        to={generateRouteUrl("EmailHistory", {
          id,
        })}
      >
        <Button size="small">History</Button>
      </Link>
    ),
  },
  {
    title: "Status",
    dataIndex: "active",
    render: (active) => (active ? "Active" : "Not Active"),
  },
  {
    title: "Multilingual",
    dataIndex: "multilingual",
    render: (multilingual, record) => (
      <Switch
        checked={!!multilingual}
        onChange={(checked) => {
          fetcher.submit(
            {
              id: record.id,
              action: "multilingual",
            },
            {
              replace: true,
              method: checked ? "POST" : "DELETE",
              encType: "application/json",
            },
          );
        }}
      />
    ),
  },
  {
    title: "Subject",
    dataIndex: "translations",
    ellipsis: true,
    render: (translations, record) => {
      if (!translations || translations.length === 0) return "-";
      if (!record.multilingual || translations.length === 1) {
        return translations[0]?.subject || "-";
      }
      const defaultTrans =
        translations.find((t) => t.language === "default") ||
        translations.find((t) => t.language === "en") ||
        translations[0];
      return defaultTrans?.subject || "-";
    },
  },
  {
    title: "Name",
    dataIndex: "name",
    ellipsis: true,
  },
  {
    title: "Scenario",
    dataIndex: "description",
    ellipsis: true,
  },
  {
    title: "Labels",
    dataIndex: "labels",
    render: (labels) => (
      <Space size={4} wrap>
        {(labels || []).map((label) => (
          <Tag
            key={label.id}
            color={label.color}
            style={{ borderRadius: 5, margin: 0, padding: "3px 8px", lineHeight: 1 }}
          >
            {label.name}
          </Tag>
        ))}
      </Space>
    ),
  },
  {
    title: "Last Updated",
    dataIndex: "updatedAt",
    render: getTimeAgo,
  },
  {
    title: "Updated By",
    dataIndex: ["user", "name"],
  },
];
